import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import Summary from "./Summary";
import { useEffect, useMemo, useState } from "react";
import ReminderList from "./ReminderList";
import useGetPatientReminders from "../PatientReminder/services/getpatientReminders";
import useGetPatientSummary from "./services/useGetPatientSummary";
import useCreatePatientSummary from "./services/useCreatePatientSummary";
import { isEmpty } from "lodash";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { faAnglesLeft } from "@fortawesome/pro-regular-svg-icons";
import ExpandCollapseButton from "../common/ExpandCollapseButton";
import CreateEditReminder from "./CreateEditReminder";
import { useContext } from "react";
import { PatientsContext } from "../Patients/PatientsContext";
import { useTranslation } from "react-i18next";
export var VIEWS = {
  SUMMARY: "summary",
  REMINDERS: "reminders",
  CREATE_EDIT_REMINDER: "create_edit_reminder"
};
var SummarySection = function SummarySection(_ref) {
  var _patient$patient_uid;
  var reminders = _ref.reminders,
    setRemindersData = _ref.setRemindersData,
    patientTags = _ref.patientTags,
    customFields = _ref.customFields,
    onToggleTags = _ref.onToggleTags,
    isTagsExpanded = _ref.isTagsExpanded,
    patient = _ref.patient,
    wsSummaryData = _ref.wsSummaryData,
    setWsSummaryData = _ref.setWsSummaryData,
    workspaceId = _ref.workspaceId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var patientUid = ((_patient$patient_uid = patient.patient_uid) === null || _patient$patient_uid === void 0 ? void 0 : _patient$patient_uid.toString()) || "";
  var _useState = useState(VIEWS.SUMMARY),
    view = _useState[0],
    setView = _useState[1];
  var _useState2 = useState(null),
    summary = _useState2[0],
    setSummary = _useState2[1];
  var _useState3 = useState(null),
    selectedReminder = _useState3[0],
    setSelectedReminder = _useState3[1];
  var _useState4 = useState(false),
    hasTriggeredSummaryCreation = _useState4[0],
    setHasTriggeredSummaryCreation = _useState4[1];
  var _useContext = useContext(PatientsContext),
    getSuggestedNextSteps = _useContext.getSuggestedNextSteps;
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        selectedNextStep: store.selectedNextStep,
        isSummaryCollapsed: store.isSummaryCollapsed,
        initialSummaryView: store.initialSummaryView,
        isSupportWidgetMinimized: store.isSupportWidgetMinimized
      };
    }),
    selectedNextStep = _useStoreState.selectedNextStep,
    isSummaryCollapsed = _useStoreState.isSummaryCollapsed,
    initialSummaryView = _useStoreState.initialSummaryView,
    isSupportWidgetMinimized = _useStoreState.isSupportWidgetMinimized;
  var reserveSpaceForMinimizedSupport = isSupportWidgetMinimized && !isSummaryCollapsed;
  var _useGetPatientReminde = useGetPatientReminders(patientUid),
    _useGetPatientReminde2 = _useGetPatientReminde.data,
    _remindersData = _useGetPatientReminde2 === void 0 ? [] : _useGetPatientReminde2,
    _refetchReminders = _useGetPatientReminde.refetch,
    isSuccess = _useGetPatientReminde.isSuccess;
  var _useGetPatientSummary = useGetPatientSummary(workspaceId, patientUid),
    _useGetPatientSummary2 = _useGetPatientSummary.data,
    summaryData = _useGetPatientSummary2 === void 0 ? {} : _useGetPatientSummary2,
    isSummarySuccess = _useGetPatientSummary.isSuccess,
    isSummaryLoading = _useGetPatientSummary.isLoading,
    isSummaryError = _useGetPatientSummary.isError,
    refetchSummary = _useGetPatientSummary.refetch,
    isSummaryFetching = _useGetPatientSummary.isFetching;

  // Get timezone info
  var tzInfo = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Initialize create summary mutation
  var createSummaryMutation = useCreatePatientSummary(workspaceId, patientUid, tzInfo);
  useEffect(function () {
    if (isSummarySuccess) {
      setSummary(summaryData);
    }
  }, [isSummarySuccess, summaryData]);
  useEffect(function () {
    if (selectedNextStep && selectedNextStep.type === "reminder") {
      var reminderAction = selectedNextStep.action;
      setSelectedReminder({
        id: 0,
        context: reminderAction.context,
        remind_after: reminderAction.remind_after
      });
      setView(VIEWS.CREATE_EDIT_REMINDER);
      Store.update(function (s) {
        s.selectedNextStep = null;
        s.isSummaryCollapsed = false;
      });
    }
  }, [selectedNextStep]);

  // Handle initial summary view from store (e.g., when navigating from ReminderCountBadge)
  useEffect(function () {
    if (initialSummaryView) {
      setSelectedReminder(null);
      if (initialSummaryView === VIEWS.CREATE_EDIT_REMINDER) {
        setView(VIEWS.CREATE_EDIT_REMINDER);
      }
      if (initialSummaryView === VIEWS.REMINDERS) {
        setView(VIEWS.REMINDERS);
      }
      // Clear the initial view after applying it
      Store.update(function (s) {
        s.initialSummaryView = null;
      });
    }
  }, [initialSummaryView]);
  useEffect(function () {
    if (isSuccess) {
      setRemindersData(_remindersData);
    }
  }, [_remindersData, isSuccess]);

  // Transform WebSocket summary data to match SummaryData type
  var wsFormattedSummary = useMemo(function () {
    if (wsSummaryData && wsSummaryData.patient_id === patient.patient_uid) {
      return {
        id: "ws_".concat(wsSummaryData.patient_id),
        patient_id: wsSummaryData.patient_id.toString(),
        summary: wsSummaryData.summary,
        additional: {},
        created_at: wsSummaryData.last_updated_at,
        updated_at: wsSummaryData.last_updated_at
      };
    }
    return null;
  }, [wsSummaryData, patient.patient_uid]);
  var refreshSummary = function refreshSummary() {
    setWsSummaryData === null || setWsSummaryData === void 0 || setWsSummaryData(null);
    setSummary(null);
    createSummaryMutation.mutateAsync();
  };

  // Reset the trigger flag when patient changes
  useEffect(function () {
    setHasTriggeredSummaryCreation(false);
  }, [patientUid]);

  // Auto-create summary if it's empty
  useEffect(function () {
    // Check if summary has loaded and is empty, and we haven't already triggered creation
    if (isSummarySuccess && !isSummaryLoading && !isSummaryFetching && isEmpty(summaryData) && !hasTriggeredSummaryCreation && workspaceId && patientUid && !createSummaryMutation.isLoading) {
      setHasTriggeredSummaryCreation(true);
      createSummaryMutation.mutateAsync();
    }
  }, [summaryData, isSummarySuccess, isSummaryLoading, isSummaryFetching, hasTriggeredSummaryCreation, workspaceId, patientUid]);
  var onAddNewReminder = function onAddNewReminder() {
    setView(VIEWS.CREATE_EDIT_REMINDER);
  };
  var onEditReminder = function onEditReminder(reminder) {
    setSelectedReminder(reminder);
    setView(VIEWS.CREATE_EDIT_REMINDER);
  };
  var onCloseCreateEditModal = function onCloseCreateEditModal() {
    setSelectedReminder(null);
    setView(VIEWS.REMINDERS);
  };
  var onBackToSummary = function onBackToSummary() {
    setView(VIEWS.SUMMARY);
  };

  // Sort reminders by remind_after date
  var sortedReminders = useMemo(function () {
    return _toConsumableArray(reminders).sort(function (a, b) {
      return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
    });
  }, [reminders]);
  var sortedUnresolvedReminders = useMemo(function () {
    return _toConsumableArray(reminders).filter(function (reminder) {
      return !reminder.resolved;
    }).sort(function (a, b) {
      return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
    });
  }, [reminders]);
  if (isSummaryCollapsed) {
    // Collapsed state - show only expand button
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col h-full bg-gray-100 dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 transition-all duration-500 ease-in-out overflow-visible"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-3 dark:bg-gray-800 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(ExpandCollapseButton, {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSummaryCollapsed = false;
        });
      },
      title: t("expand_summary"),
      icon: faAnglesLeft
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col border-l overflow-visible bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-700 transition-all duration-500 ease-in-out ".concat(reserveSpaceForMinimizedSupport ? "min-h-0" : "h-full"),
    style: reserveSpaceForMinimizedSupport ? {
      height: "calc(100% - 53px)"
    } : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full min-h-0 flex flex-col animate-expandSummary overflow-hidden"
  }, view === VIEWS.SUMMARY && /*#__PURE__*/React.createElement(Summary, {
    latestReminder: sortedUnresolvedReminders[0],
    remindersCount: sortedReminders.length,
    patientTags: patientTags,
    customFields: customFields,
    showReminders: function showReminders() {
      return setView(VIEWS.REMINDERS);
    },
    onToggleTags: onToggleTags,
    isTagsExpanded: isTagsExpanded,
    summary: wsFormattedSummary || summary,
    onRefreshSummary: refreshSummary,
    onRefetchSummary: refetchSummary,
    isSummaryLoading: isSummaryFetching || createSummaryMutation.isLoading,
    isSummaryGenerating: !wsFormattedSummary && !summary && createSummaryMutation.isSuccess,
    hasError: isSummaryError
  }), view === VIEWS.REMINDERS && /*#__PURE__*/React.createElement(ReminderList, {
    data: sortedReminders,
    patient_uid: patientUid,
    onAddNewReminder: onAddNewReminder,
    onEditReminder: onEditReminder,
    onBackToSummary: onBackToSummary,
    refetchReminders: _refetchReminders,
    workspaceId: workspaceId
  }), view === VIEWS.CREATE_EDIT_REMINDER && /*#__PURE__*/React.createElement(CreateEditReminder, {
    patientUid: patientUid,
    onCloseCreateEditModal: onCloseCreateEditModal,
    selectedReminder: selectedReminder,
    refetchReminders: function refetchReminders() {
      _refetchReminders();
      getSuggestedNextSteps();
    }
  })));
};
export default SummarySection;